import moment from "moment";
import users from "./users";
import { get_unduplicate_array_by_prop } from "./pivot_table_utils";

export default [
  {
    title: "ID",
    align: "center",
    dataIndex: "id",
    sorter: (a, b) => {
      return a.id - b.id;
    },
  },
  {
    title: "Voyage Year",
    align: "center",
    dataIndex: "voyage_year",
    scopedSlots: {
      filterDropdown: "filterDropdown",
      filterIcon: "filterIcon",
      customRender: "search_filter",
    },
    onFilter: (value, record) => {
      return record.voyage_year
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase());
    },
  },
  {
    title: "M.V.",
    align: "center",
    dataIndex: "mv",
    scopedSlots: {
      filterDropdown: "filterDropdown",
      filterIcon: "filterIcon",
      customRender: "search_filter",
    },
    onFilter: (value, record) =>
      record.mv.toString().toLowerCase().includes(value.toLowerCase()),
  },
  {
    title: "Charterer",
    align: "center",
    dataIndex: "charterer",
    width: 120,
    scopedSlots: {
      filterDropdown: "filterDropdown",
      filterIcon: "filterIcon",
      customRender: "search_filter",
    },
    onFilter: (value, record) =>
      record.charterer.toString().toLowerCase().includes(value.toLowerCase()),
  },
  {
    title: "Laycan",
    align: "center",
    scopedSlots: { customRender: "laycan" },
    sorter: (a, b) => {
      if (a.laycan[0] !== "" && b.laycan[0] !== "") {
        return moment(a.laycan[0]).diff(moment(b.laycan[0]));
      }
      if (a.laycan.length == 0 || b.laycan.length == 0) {
        return false;
      }
      return false;
    },
  },
  {
    title: "Load Port ~ Disc. Port",
    align: "center",
    scopedSlots: { customRender: "load_disc_port" },
  },
  {
    title: "B/L and Freight (CP vs Perf. )",
    align: "center",
    dataIndex: "id",
    scopedSlots: {
      filterDropdown: "filterDropdown",
      filterIcon: "filterIcon",
      customRender: "search_cargo_filter",
    },
    onFilter: (value, record) => {
      let flag = false;
      get_unduplicate_array_by_prop([record], "cargo").forEach((c) => {
        if (c.toLowerCase().includes(value.toLowerCase())) {
          flag = true;
        }
      });
      return flag;
    },
  },
  {
    title: "P&L",
    align: "center",
    scopedSlots: { customRender: "pl" },
  },
  {
    title: "Creator",
    align: "center",
    dataIndex: "creator",
    scopedSlots: {
      filterDropdown: "filterDropdown",
      filterIcon: "filterIcon",
      customRender: "search_filter",
    },
    onFilter: (value, record) => {
      return users
        .find((u) => u.id == record.creator)
        .name.toString()
        .toLowerCase()
        .includes(value.toLowerCase());
    },
  },
];
